module.exports = __webpack_public_path__ + "img/symphony_720_forest.da1a0303.jpg";